<div class="container my-4">
    <div class="row">
      <div class="col-12 ">
        <span class="title_header_bar">Courier Waybill</span>
      </div>
    </div>
    <div class="card card_content">
  <form [formGroup]="form">
    <div class="row d-flex justify-content-center align-items-center flex-wrap grid-margin mt-4">
        <div class="col-md-4 padd-right-file" style="display: flex;">
          <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'searchText-mat-field'">
            <mat-label>Search</mat-label>
            <div class="search-input-container">
              <input placeholder="Enter Application Number" id="search" matInput formControlName="search"
               type="text" #searchInput>
            </div>
          </mat-form-field>
          <button matSuffix mat-icon-button aria-label="Search" class="badge bg-light-blue image-button"
            (click)="searchinput()">
            <mat-icon style="color: white;">search</mat-icon>
          </button>
        </div>
        <div class="col-2">
          <button type="button" class="btn reset_btn" (click)="clearFilter()">
            <i class="fa fa-refresh"></i> reset
          </button>


        </div>
      </div>
    
    </form>
    </div>
    </div>